import React from "react";
import { Form, InputGroup, Button, Container, Row, Col } from "react-bootstrap";
import { handleChange } from "presentation/utils/functions/generic";

import { evaluationSchemeFrequencyTypes, evaluationSchemeDependencyTypes } from "presentation/model/constants";

class FinalResultTabEvaluationSchemeForm extends React.Component {
    constructor(props) {
        super(props);

    }
    render() {
        let { component, evaluationSchemeForm } = this.props;
        let calculateFrequencyByDiscipline = evaluationSchemeForm.calculateFrequencyByDiscipline ? 1 : 0;
        let approveWhenExceedMaxDisciplinesFailure = evaluationSchemeForm.approveWhenExceedMaxDisciplinesFailure ? 1 : 0;

        return (
            <Container>
                <Row>
                    <Col>
                        <h4>Resultado final</h4>
                    </Col>
                </Row>
                <Row>
                    <Col lg={6}>
                        <div className="form mt-2">
                            <Form.Label htmlFor="periodAverageLimit">Limite para resultado ao fim dos PERÍODOS</Form.Label>
                            <Form.Control
                                type="text"
                                id="periodAverageLimit"
                                name="periodAverageLimit"
                                defaultValue={evaluationSchemeForm.periodAverageLimit}
                                onChange={(e) => handleChange(e, component, 'evaluationSchemeForm')}
                            />
                        </div>
                    </Col>
                    <Col lg={6}>
                        <div className="form mt-2">
                            <Form.Label htmlFor="stageAverageLimit">Limite para resultado ao fim das ETAPAS</Form.Label>
                            <Form.Control
                                type="text"
                                id="stageAverageLimit"
                                name="stageAverageLimit"
                                defaultValue={evaluationSchemeForm.stageAverageLimit}
                                onChange={(e) => handleChange(e, component, 'evaluationSchemeForm')}
                            />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h5 className="mt-4">Situação final</h5>
                        <p>A situação final do aluno é considerada após obtenção do resultado individual de todas as disicplinas passíveis de avaliação</p>
                        <table className="table mt-2">
                            <thead>
                                <tr>
                                    <th width="70%">Critério</th>
                                    <th width="30%">Situação final</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <InputGroup>
                                            <InputGroup.Checkbox
                                                checked={evaluationSchemeForm.frequencyIsACriteria || false}
                                                id={`frequencyIsACriteria`}
                                                name={`frequencyIsACriteria`}
                                                data-field-name="frequencyIsACriteria"
                                                onChange={(event) => handleChange(event, component, 'evaluationSchemeForm')}
                                            />
                                            <InputGroup.Text>Se a frequência</InputGroup.Text>
                                            <Form.Select
                                                aria-label="Tipo de frequência"
                                                defaultValue={calculateFrequencyByDiscipline}
                                                id={`calculateFrequencyByDiscipline`}
                                                name={`calculateFrequencyByDiscipline`}
                                                data-field-name="calculateFrequencyByDiscipline"
                                                onChange={(e) => handleChange(e, component, 'evaluationSchemeForm')}
                                            >
                                                {evaluationSchemeFrequencyTypes.map((e, i) => { return <option key={e.id} value={e.id}>{e.name}</option> })}
                                            </Form.Select>
                                            <InputGroup.Text>for menor que</InputGroup.Text>
                                            <Form.Control
                                                type="text"
                                                id="requiredFrequencyPercentage"
                                                name="requiredFrequencyPercentage"
                                                defaultValue={evaluationSchemeForm.requiredFrequencyPercentage}
                                                data-field-name="requiredFrequencyPercentage"
                                                onChange={(e) => handleChange(e, component, 'evaluationSchemeForm')}
                                            />
                                            <InputGroup.Text>%</InputGroup.Text>
                                        </InputGroup>
                                    </td>
                                    <td>
                                        Reprovado (independente de qualquer outro critério)
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <InputGroup>
                                            <InputGroup.Text>Se reprovado em</InputGroup.Text>
                                            <Form.Control
                                                type="text"
                                                disabled
                                                defaultValue={0}
                                            />
                                            <InputGroup.Text>disciplina(s)</InputGroup.Text>
                                        </InputGroup>
                                    </td>
                                    <td>
                                        Aprovado
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <InputGroup>
                                            <InputGroup.Checkbox
                                                checked={evaluationSchemeForm.allowDependency || false}
                                                id={`allowDependency`}
                                                name={`allowDependency`}
                                                data-field-name="allowDependency"
                                                onChange={(event) => handleChange(event, component, 'evaluationSchemeForm')}
                                            />
                                            <InputGroup.Text>Se reprovado em até</InputGroup.Text>
                                            <Form.Control
                                                type="text"
                                                id="maxDisciplinesFailure"
                                                name="maxDisciplinesFailure"
                                                defaultValue={evaluationSchemeForm.maxDisciplinesFailure}
                                                onChange={(e) => handleChange(e, component, 'evaluationSchemeForm')}
                                            />
                                        </InputGroup>
                                    </td>
                                    <td>
                                        <InputGroup>
                                            <InputGroup.Text>
                                                Aprovado
                                            </InputGroup.Text>
                                            <Form.Select
                                                aria-label="Dependência"
                                                defaultValue={approveWhenExceedMaxDisciplinesFailure}
                                                id={`approveWhenExceedMaxDisciplinesFailure`}
                                                name={`approveWhenExceedMaxDisciplinesFailure`}
                                                data-field-name="approveWhenExceedMaxDisciplinesFailure"
                                                onChange={(e) => handleChange(e, component, 'evaluationSchemeForm')}
                                            >
                                                {evaluationSchemeDependencyTypes.map((e, i) => { return <option key={e.id} value={e.id}>{e.name}</option> })}
                                            </Form.Select>
                                        </InputGroup>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <InputGroup>
                                            <InputGroup.Text>Se reprovado em mais de</InputGroup.Text>
                                            <Form.Control
                                                type="text"
                                                disabled
                                                value={evaluationSchemeForm.maxDisciplinesFailure}
                                            />
                                            <InputGroup.Text>disciplina(s)</InputGroup.Text>
                                        </InputGroup>
                                    </td>
                                    <td>
                                        Reprovado
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </Col>
                </Row>
            </Container >
        );
    };
}

export default FinalResultTabEvaluationSchemeForm;